import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { Subscription, SubscriptionLine } from "src/app/shared/models/DTO/VenueFinance.dto";

@Component({
	selector: "app-service-subscription-list",
	templateUrl: "./service-subscription-list.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class ServiceSubscriptionListComponent implements OnInit {
	@Input() service: Subscription;
	@Output() serviceChange = new EventEmitter<Subscription>();

	serviceLines: SubscriptionLine[];

	constructor(public app: AppService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		this.venueService.venueFinance.subscribe((data) => {
			if (data.subscriptions) {
				this.consolidateServiceLines(data.subscriptions);
			}
		});

		if (this.venueService.venueFinance.value.subscriptions) {
			this.consolidateServiceLines(this.venueService.venueFinance.value.subscriptions);
		}
	}

	consolidateServiceLines(services: Subscription[]) {
		let localServiceLines = [];
		services.forEach((service) => {
			if (service.active) {
				localServiceLines = localServiceLines.concat(
					service.lines.map((line) => {
						const sl = new SubscriptionLine(line);
						sl.billingFrequency = service.billingFrequency;
						sl.nextBillingDate = service.nextBillingDate;
						sl.autoBillPay = service.autoBillPay;
						sl.autoBillPayPaymentMedium = service.autoBillPayPaymentMedium;
						return sl;
					})
				);
			}
		});
		this.serviceLines = localServiceLines;
	}
}
